import { startOfToday } from 'date-fns';

import { formatByLocale } from 'utils/date';

import { Box, TextField } from '@mui/material';

import DatePicker from '../DatePicker/DatePicker';

type Props = {
  date?: Date | null;
  placeholder: string;
  onChange: (date: Date | null) => void;
  error?: boolean;
  helperText?: string;
};

export default function WeekNumberPicker({
  date,
  placeholder,
  error,
  onChange,
  helperText
}: Props) {
  const _date = date || startOfToday();
  return (
    <TextField
      value={date ? formatByLocale(date) : null}
      sx={{ width: '150px' }}
      placeholder={placeholder}
      error={error}
      helperText={helperText}
      InputProps={{
        readOnly: true,
        startAdornment: date && (
          <Box mr={1} width="30px" color="gray" sx={{ fontSize: '12px' }}>
            {formatByLocale(date, 'w')}
          </Box>
        ),
        endAdornment: (
          <DatePicker
            onChange={(date) => {
              if (date) {
                onChange(date as Date);
              }
            }}
            date={_date as Date}
          />
        )
      }}
    />
  );
}
